import { Box, Image, Text } from "@chakra-ui/react";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Skills() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <Box>
      <Box>
        <Text
          mb={"60px"}
          color={"#FFB6C1"}
          mt={20}
          textDecoration={"underline"}
          fontSize={{ base: "30px", md: "45px", lg: "60px" }}
        >
          Technical Skills
        </Text>
      </Box>

      <Box
        data-aos="fade-right"
        margin={"auto"}
        mb="80px"
        w="80%"
        justifyContent="center"
        alignContent={"center"}
        className="project"
      >
        <Box textAlign="center">
          <Text
            color={"#FFB6C1"}
            fontSize={{ base: "21px", md: "27px", lg: "38px" }}
            pt={30}
          >
            Frontend
          </Text>
        </Box>
        <Box
         className="skills-card"
          display={"grid"}
          gridTemplateColumns={{
            base: "repeat(2,1fr)",
            md: "repeat(2,1fr)",
            lg: "repeat(5,1fr)",
          }}
          gap="50px"
          mt={"70px"}
        >
          <Image
            className="skills-card-img"
            w={{ base: "120px", md: "150px", lg: "200px" }}
            src="https://www.freepnglogos.com/uploads/html5-logo-png/html5-logo-image-logo-html-7.png"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "80px", md: "150px", lg: "120px" }}
            src="https://www.freepnglogos.com/uploads/html5-logo-png/html5-logo-css-logo-png-transparent-svg-vector-bie-supply-9.png"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "70px", md: "140px", lg: "120px" }}
            src="https://www.freepnglogos.com/uploads/javascript-png/javascript-shield-logo-icon-2.png"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "70px", md: "140px", lg: "120px" }}
            src="https://res.cloudinary.com/practicaldev/image/fetch/s--JIe3p0M4--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/i/093ewdrgyf1kedlhzs51.png"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "70px", md: "140px", lg: "100px" }}
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTOR5hKSUzLmJO6RXvSr8bEIB2Fk8VeNF4DA&usqp=CAU"
          ></Image>
        </Box>
      </Box>

      <Box
        data-aos="fade-right"
        margin={"auto"}
        w="80%"
        justifyContent="center"
        alignContent={"center"}
        className="project"
      >
        <Box textAlign="center">
          <Text
            color={"#FFB6C1"}
            fontSize={{ base: "21px", md: "27px", lg: "38px" }}
            pt={30}
          >
            Backend
          </Text>
        </Box>
        <Box
         className="skills-card"
          display={"grid"}
          gridTemplateColumns={{
            base: "repeat(2,1fr)",
            md: "repeat(2,1fr)",
            lg: "repeat(3,1fr)",
          }}
          gap="30px"
          mt={"70px"}
        >
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "100px", md: "200px", lg: "300px" }}
            src="data:image/png;base64,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"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "100px", md: "200px", lg: "300px" }}
            src="http://4.bp.blogspot.com/-R2D3RLQuP_U/VAAWQqa1GdI/AAAAAAAAAuw/GqaHO06qcl0/s1600/mango%2BDB.PNG"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "100px", md: "200px", lg: "300px" }}
            src="https://searchlogovector.com/wp-content/uploads/2018/08/express-inc-logo-vector.png"
          ></Image>
        </Box>
      </Box>

      <Box
        data-aos="fade-right"
        margin={"auto"}
        mt="80px"
        w="80%"
        justifyContent="center"
        alignContent={"center"}
        className="project"
      >
        <Box textAlign="center">
          <Text
            color={"#FFB6C1"}
            fontSize={{ base: "21px", md: "27px", lg: "38px" }}
            pt={30}
          >
            Tools
          </Text>
        </Box>
        <Box
        className="skills-card"
          display={"grid"}
          gridTemplateColumns={{
            base: "repeat(2,1fr)",
            md: "repeat(2,1fr)",
            lg: "repeat(3,1fr)",
          }}
          gap="30px"
          mt={"70px"}
        >
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "50px", md: "70px", lg: "130px" }}
            src="https://cdn-icons-png.flaticon.com/512/25/25231.png"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "50px", md: "70px", lg: "130px" }}
            src="https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png"
          ></Image>
          <Image
            className="skills-card-img"
            // className="skills"
            w={{ base: "50px", md: "70px", lg: "130px" }}
            src="https://code.visualstudio.com/assets/images/code-stable.png"
          ></Image>
        </Box>
      </Box>
    </Box>
  );
}

export default Skills;
